import { Injectable } from '@angular/core';
import { HttpRequest } from '@angular/common/http';
import { HttpHandler } from '@angular/common/http';
import { Observable } from 'rxjs';
import { HttpEvent } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { NgRedux } from '@angular-redux/store';
import { AppState } from '../../../store/state.model';
import { CustomHttpParams } from '../api-handler/api-handler.service';
import { Guid } from 'guid-typescript';

@Injectable()
export class HeaderInterceptorService {
  constructor(public ngRedux: NgRedux<AppState>) { }
  /**
   * @method intercept =Intercepts the http call to add headers
   */
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let headers = {};
    const type = (req.params instanceof CustomHttpParams) ? req.params.spec : '';
    if (req.params instanceof CustomHttpParams && req.params.spec) {
      switch (type) {
        case 'asi':
          headers = this.getAsiHeaders();
          break;
        default:
          headers = this.getHeaders(type);
      }
    }

    return next.handle(req.clone({
      setHeaders: headers
    }));
  }
  /**
   * @method getHeaders return headers for the api calls
   * @returns header object
   */
  private getHeaders(type): object {
    let obj;
    if (type === 'getpackage' || type === 'getproductids') {
      // type = 'getpackage'
      obj = {
        'X-CORRELATIONID': Guid.create().toString(),
        'X-CHANNEL': 'ORCH_PROD',
      };
      obj = (type === 'getpackage') ? Object.assign(obj, { 'generation': this.ngRedux.getState().file.generation }) : obj;
    } else {
      // type = 'package', 'getasi', 'getGeneration', 'approve-package', 'approve-asi', getUserRole,'asi-product-map'
      obj = {
        'X-CORRELATIONID': Guid.create().toString(),
        'X-channel': environment.ProductCatalog.package_x_channel
      };
      obj = (type === 'getasi') ? Object.assign(obj, { 'generation': this.ngRedux.getState().file.generation }) : obj;
    }
    obj = Object.assign(obj, {
       'User-email': !!this.ngRedux.getState().auth.email ? this.ngRedux.getState().auth.email.toLowerCase() : ''
    });
    return obj;
  }
  /**
   * @method getAsiHeaders return asi headers for the api call
   * @returns header object
   */
  private getAsiHeaders(): object {
    // type = 'asi'
    return {
      'X-CORRELATIONID': Guid.create().toString(),
      'x-channel': 'TEST',
      'User-email': this.ngRedux.getState().auth.email
    };
  }
}
